// Formatea fechas siempre en la zona horaria del TENANT (nunca la del
// navegador): el bug reportado fue que la lista de publicaciones mostraba
// una hora distinta a la que el usuario cargó en el formulario, porque
// renderizaba en la zona horaria local del navegador con reloj de 12h sin
// am/pm ("07:32" en vez de "18:32 (EDT)").
export function formatTenantDateTime(isoString, timezone) {
  if (!isoString) return "—";
  const tz = timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const date = new Date(isoString);
  const datePart = new Intl.DateTimeFormat("es-AR", {
    timeZone: tz, day: "2-digit", month: "2-digit", year: "numeric",
  }).format(date);
  const timePart = new Intl.DateTimeFormat("es-AR", {
    timeZone: tz, hour: "2-digit", minute: "2-digit", hour12: false,
  }).format(date);
  const tzName = new Intl.DateTimeFormat("en-US", { timeZone: tz, timeZoneName: "short" })
    .formatToParts(date).find((p) => p.type === "timeZoneName")?.value;
  return `${datePart}, ${timePart}${tzName ? ` (${tzName})` : ""}`;
}

// Clave "YYYY-MM-DD" del día calendario correspondiente en esa zona horaria
// (para agrupar eventos por día sin mezclarlo con la zona del navegador).
export function tenantDayKey(isoString, timezone) {
  if (!isoString) return "";
  const tz = timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: tz, year: "numeric", month: "2-digit", day: "2-digit",
  }).format(new Date(isoString));
}
